import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { scrollToId } from "@/lib/site";

export default function WorkBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} className="relative overflow-hidden py-24 md:py-32" data-testid="work-band">
      <motion.img
        src="/images/pool-exterior.jpg"
        alt="Exterior repaint — painted brick home with pool, Central Florida"
        style={{ y }}
        className="absolute inset-0 h-[120%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-navy/70" />
      <div className="relative z-10 mx-auto max-w-[1200px] px-5 text-center md:px-8">
        <p className="eyebrow !text-[#e8a33d]">Our work</p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-4xl font-light leading-[1.12] text-white md:text-5xl">
          Fresh coats across <em className="italic">Central Florida.</em>
        </h2>
        <button data-testid="work-band-cta" onClick={() => scrollToId("#gallery")} className="btn-amber mt-9">
          View Our Work
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </section>
  );
}
